export default {"src":"/_next/static/media/borrower.53084d7b.svg","height":329,"width":403,"blurWidth":0,"blurHeight":0};